import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconFolder1"><Path d="M4.75 3C3.23122 3 2 4.23122 2 5.75V17.25C2 18.7688 3.23122 20 4.75 20H19.25C20.7688 20 22 18.7688 22 17.25V8.75C22 7.23122 20.7688 6 19.25 6H13.0704C12.6524 6 12.2621 5.79112 12.0303 5.44338L11.2178 4.22457C10.7077 3.45953 9.8491 3 8.92963 3H4.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolder1;
